export default __webpack_public_path__ + "static/Hanken_logo-c53933b3f6e556c7122a700fad74ed3a.png";